// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2073":"388da921","7896":"86b47cbe"}[chunkId] + ".chunk.css";
};